var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "history"
  }, [_c('div', {
    staticClass: "history-main"
  }, [_c('div', {
    staticClass: "history-title"
  }, [_c('div', {
    staticClass: "history-title-main"
  }, [_c('div', {
    staticClass: "history__title"
  }, [_vm._v("Current Balance")]), _c('div', {
    staticClass: "history-balance"
  }, [_c('div', {
    staticClass: "history-balance-item coin"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-coin.png'),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.fmt_pre(_vm.userInfo.coin)))]), _c('div', {
    staticClass: "history-balance-item star"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-star.png'),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.fmt_pre(_vm.userInfo.stars)) + " "), _c('div', {
    directives: [{
      name: "tip",
      rawName: "v-tip.bottom.click",
      value: `Coming Soon`,
      expression: "`Coming Soon`",
      modifiers: {
        "bottom": true,
        "click": true
      }
    }],
    staticClass: "btn-withdraw"
  }, [_vm._v("withdraw")])])])])]), _c('div', {
    staticClass: "history-total"
  }, [_c('div', {
    staticClass: "history-total-item"
  }, [_c('div', {
    staticClass: "history-total-item-main"
  }, [_vm._v(" Wins "), _c('span', {
    staticClass: "win"
  }, [_vm._v(_vm._s(_vm.fmt_pre(_vm.userInfo.wins)))])])]), _c('div', {
    staticClass: "history-total-item"
  }, [_c('div', {
    staticClass: "history-total-item-main"
  }, [_vm._v(" Winrate "), _c('span', {
    staticClass: "winrate"
  }, [_vm._v(_vm._s(_vm.fmt_pre(_vm.userInfo.wins / (Number(_vm.userInfo.wins) + Number(_vm.userInfo.loses)) * 100)) + "%")])])]), _c('div', {
    staticClass: "history-total-item"
  }, [_c('div', {
    staticClass: "history-total-item-main"
  }, [_vm._v(" Loses "), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.userInfo.loses)))])])])]), _c('div', {
    staticClass: "history-tab"
  }, [_c('m-tab', {
    attrs: {
      "tab": _vm.tabList,
      "selectTab": _vm.selectTab
    },
    on: {
      "update:selectTab": function ($event) {
        _vm.selectTab = $event;
      },
      "update:select-tab": function ($event) {
        _vm.selectTab = $event;
      }
    }
  })], 1), _c('div', {
    staticClass: "history-list"
  }, [_vm.selectTab && _vm.selectTab.value === 0 ? [_c('div', {
    staticClass: "history-list__title"
  }, [_vm._v("TRANSACTION LIST")]), _c('div', {
    staticClass: "history-list-main"
  }, [_vm.transactionList ? [_vm.transactionList.length ? _vm._l(_vm.transactionList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "history-item"
    }, [_c('div', {
      staticClass: "history-item__img"
    }, [item.reason == 'Correct Prediction' ? [_c('img', {
      attrs: {
        "src": require('@images/icon/icon-correctPrediction.png'),
        "alt": ""
      }
    })] : item.reason == 'Deposit' ? [_c('img', {
      attrs: {
        "src": require('@images/icon/icon-deposit.png'),
        "alt": ""
      }
    })] : item.reason == 'Buy Ticket' ? [_c('img', {
      attrs: {
        "src": require('@images/icon/icon-buyTicket.png'),
        "alt": ""
      }
    })] : item.reason == 'Instant Reward' ? [_c('img', {
      attrs: {
        "src": require('@images/icon/icon-instantReward.png'),
        "alt": ""
      }
    })] : item.reason == 'Task Completed' ? [_c('img', {
      attrs: {
        "src": require('@images/icon/icon-taskCompleted.png'),
        "alt": ""
      }
    })] : item.reason == 'Invitation Reward' ? [_c('img', {
      attrs: {
        "src": require('@images/icon/pop-invitationReward.png'),
        "alt": ""
      }
    })] : item.reason == 'Correct Prediction' ? [_c('img', {
      attrs: {
        "src": require('@images/icon/icon-correctPrediction.png'),
        "alt": ""
      }
    })] : item.reason == 'Wrong Prediction' ? [_c('img', {
      attrs: {
        "src": require('@images/icon/icon-wrongPrediction.png'),
        "alt": ""
      }
    })] : _vm._e()], 2), _c('div', {
      staticClass: "history-item-info"
    }, [_c('div', {
      staticClass: "history-item__title"
    }, [_vm._v(_vm._s(item.reason))]), _c('div', {
      staticClass: "history-item__time"
    }, [_vm._v(" " + _vm._s(_vm.fmt_time(item.created_at).format("MMM DD HH:mm ")) + " ")])]), _c('div', {
      staticClass: "history-item-reward"
    }, [_c('div', {
      staticClass: "history-item-reward__num"
    }, [item.coin > 0 ? _c('i', {
      class: item.coin_direction == 'out' && 'out'
    }, [_c('img', {
      attrs: {
        "src": require('@images/icon/icon-coin.png'),
        "alt": ""
      }
    }), _vm._v(_vm._s(item.coin_direction == "in" ? "+" : "-") + _vm._s(_vm.fmt_pre(item.coin)))]) : _vm._e(), item.ticket > 0 ? _c('i', {
      class: item.ticket_direction == 'out' && 'out'
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.svg_tickets)
      }
    }), _vm._v(_vm._s(item.ticket_direction == "in" ? "+" : "-") + _vm._s(_vm.fmt_pre(item.ticket)))]) : _vm._e(), item.stars > 0 ? _c('i', {
      class: item.stars_direction == 'out' && 'out'
    }, [_c('img', {
      attrs: {
        "src": require('@images/icon/icon-star.png'),
        "alt": ""
      }
    }), _vm._v(_vm._s(item.stars_direction == "in" ? "+" : "-") + _vm._s(_vm.fmt_pre(item.stars)))]) : _vm._e()])])]);
  }) : [_c('div', {
    staticClass: "history__info"
  }, [_vm._v("No transaction record!")])]] : [_vm._m(0)]], 2)] : _vm._e(), _vm.selectTab && _vm.selectTab.value === 1 ? [_c('div', {
    staticClass: "history-list__title"
  }, [_vm._v("COMPLETED EVENTS")]), _c('div', {
    staticClass: "history-list-main"
  }, [_vm.CompletedEventsList ? [_vm.CompletedEventsList.length ? _vm._l(_vm.CompletedEventsList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "history-item"
    }, [_c('div', {
      staticClass: "history-item-info"
    }, [_c('div', {
      staticClass: "history-item__title",
      domProps: {
        "innerHTML": _vm._s(item.title.replace(/\*(.*?)\*/g, `<em style='color:#fed629'>$1</em>`))
      }
    }), _c('div', {
      staticClass: "history-item__time"
    }, [_vm._v(" " + _vm._s(_vm.fmt_time(item.created_at).format("MMM DD HH:mm ")) + " ")])]), _c('div', {
      staticClass: "history-item-reward"
    }, [_c('div', {
      staticClass: "history-item-reward__num"
    }, [item.reward_coin > 0 ? _c('i', [_c('img', {
      attrs: {
        "src": require('@images/icon/icon-coin.png'),
        "alt": ""
      }
    }), _vm._v("+" + _vm._s(_vm.fmt_pre(item.reward_coin)))]) : _vm._e(), item.reward_ticket > 0 ? _c('i', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.svg_tickets)
      }
    }), _vm._v("+" + _vm._s(_vm.fmt_pre(item.reward_ticket)))]) : _vm._e()]), _c('div', {
      staticClass: "history-item-reward__tag"
    }, [_c('span', [_vm._v("Choice: " + _vm._s(item.choice_text))]), _c('span', {
      class: item.is_win && 'win'
    }, [_vm._v(_vm._s(item.is_win === 0 ? "Lose" : "Win"))])])])]);
  }) : [_c('div', {
    staticClass: "history__info"
  }, [_vm._v("No completed events!")])]] : [_vm._m(1)]], 2)] : _vm._e()], 2)]), _c('m-menu')], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "history__loading"
  }, [_c('div', {
    staticClass: "circleLoading"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "history__loading"
  }, [_c('div', {
    staticClass: "circleLoading"
  })]);
}];
export { render, staticRenderFns };